// extracted by mini-css-extract-plugin
export var dropdown = "_ug-0";
export var imageWrapper = "_ug-3";
export var itemNameContainer = "_ug-1";
export var productImage = "_ug-2";
export var spinnerWrapper = "_ug-4";